import { useMutation, useQuery } from "react-query";
import {
  addMultipleItems,
  chatWithAI,
  chatWithAIMulti,
  deleteItem,
  fetchDetailItem,
  fetchListItems,
  fetchPercentageMatchedQuestion,
  updateItem,
} from "../api";
import { IDetailItem, IGetList, IItems } from "@/common";
import { IQueryOptions } from ".";

interface IGetListItems {
  query: IGetList;
  options?: IQueryOptions;
}

export const useGetListItems = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery(["fetchListItems"], () => fetchListItems(query), {
    keepPreviousData: true,
    staleTime: Infinity,
    ...options,
  });
};

export const useGetListItemsAssessment = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery(["fetchListItemsAssessment", query], () => fetchListItems(query), {
    keepPreviousData: true,
    ...options,
  });
};

export const useGetDetailQuestion = (payload: IQueryOptions & IDetailItem) => {
  const { id, ...options } = payload;
  return useQuery(["fetchDetailQuestion"], () => fetchDetailItem({ id }), {
    keepPreviousData: true,
    ...options,
  });
};

export const useGetDetailItem = (payload: IQueryOptions & IDetailItem) => {
  const { id, ...options } = payload;
  return useQuery(["fetchDetailItem"], () => fetchDetailItem({ id }), {
    keepPreviousData: true,
    ...options,
  });
};

export const useGetDetailAspect = (payload: IQueryOptions & IDetailItem) => {
  const { id, ...options } = payload;
  return useQuery(["fetchDetailAspect"], () => fetchDetailItem({ id }), {
    keepPreviousData: true,
    ...options,
  });
};

export const useGetTopicsAll = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery(["fetchAllTopics"], () => fetchListItems(query), {
    keepPreviousData: true,
    staleTime: Infinity,
    ...options,
  });
};

export const useGetQuestionsOfTopicAll = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery(["fetchAllQuestionsofTopic", query], () => fetchListItems(query), {
    keepPreviousData: true,
    staleTime: Infinity,
    ...options,
  });
};

export const useGetGroupQuestionPart2All = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery<IItems[]>(["fetchListGroupQuestionPart2All"], () => fetchListItems(query), {
    keepPreviousData: true,
    staleTime: Infinity,
    ...options,
  });
};

export const useGetQuestionPart2All = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery<IItems[]>(["fetchListQuestionPart2All"], () => fetchListItems(query), {
    keepPreviousData: true,
    ...options,
  });
};

export const useAddMultipleItems = (options: IQueryOptions) => {
  return useMutation(addMultipleItems, options);
};

export const useUpdateItem = (options: IQueryOptions) => {
  return useMutation(updateItem, options);
};

export const useDeleteItem = (options: IQueryOptions) => {
  return useMutation(deleteItem, options);
};

export const useChatWithAI = (options: IQueryOptions) => {
  return useMutation(chatWithAI, options);
};

export const useChatWithAIMulti = (options: IQueryOptions) => {
  return useMutation(chatWithAIMulti, options);
};

export const useGetPercentageMatchedQuestion = (payload: IQueryOptions & IDetailItem & { aspectType: string }) => {
  const { id, aspectType, ...options } = payload;
  return useQuery(
    ["fetchPercentageMatchedQuestion", id, aspectType],
    () => fetchPercentageMatchedQuestion({ id, aspectType }),
    {
      keepPreviousData: true,
      ...options,
    }
  );
};

export const useGetListIdeas = (payload: IGetListItems) => {
  const { query, options = {} } = payload;
  return useQuery(["fetchListIdeas", query.parentId, query.questionId], () => fetchListItems(query), {
    keepPreviousData: true,
    ...options,
  });
};

export const useGetReactionTestQuestions = (options?: IQueryOptions) => {
  return useQuery<IItems[]>(
    ["fetchReactionTestQuestions"],
    () =>
      fetchListItems({
        skip: 0,
        limit: 300,
        parentId: "*",
        type: "question,question.part2,group.question.part2",
      }),
    {
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true,
      ...options,
    }
  );
};

export const useGetReactionTestTopics = (options?: IQueryOptions) => {
  return useQuery<IItems[]>(
    ["fetchReactionTestTopics"],
    () =>
      fetchListItems({
        skip: 0,
        limit: 100,
        parentId: "*",
        type: "topic",
      }),
    {
      staleTime: 15 * 60 * 1000,
      keepPreviousData: true,
      ...options,
    }
  );
};
